import { createSlice } from '@reduxjs/toolkit';
import { submitReportsSettingsForm } from '@custom/rtk-apis/report/submitReportsSettingsForm';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const reportsSettingsSlice = createSlice({
  name: 'reportsSettings',
  initialState,
  reducers: {
    closeUpdateModal (state:any) { state.status = ""; }

  },
  extraReducers: (builder) => {
    builder
      .addCase(submitReportsSettingsForm.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(submitReportsSettingsForm.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(submitReportsSettingsForm.rejected, (state, { error }) => {
        state.loading = false;
        state.error = error.message;
      });
  },
});

export default reportsSettingsSlice.reducer;
export const { closeUpdateModal } = reportsSettingsSlice.actions;
